import { render } from "./ModelColors.vue?vue&type=template&id=442d5bab&scoped=true"
import script from "./ModelColors.vue?vue&type=script&lang=js"
export * from "./ModelColors.vue?vue&type=script&lang=js"

import "./ModelColors.vue?vue&type=style&index=0&id=442d5bab&scoped=true&lang=css"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442d5bab"]])

export default __exports__